import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { getFeatureToggle } from '@capital-access/common/feature-toggle';
import { NavConfig, NavConfigFn, NavigationConfigProvider } from '@capital-access/common/navigation';
import { AI_SEARCH_PATH, INTELLIGENT_SEARCH_FEATURE_TOGGLE } from './constants';

@Injectable()
export class AiSearchNavConfigProvider implements NavigationConfigProvider {
  constructor(private store: Store) {}

  resolveNavConfig: NavConfigFn = () => {
    return this.store.select(getFeatureToggle(INTELLIGENT_SEARCH_FEATURE_TOGGLE)).pipe(
      map(isEnabled => {
        return <NavConfig>{
          top: [
            {
              localizationKey: 'search',
              icon: 'f-i-search',
              order: 70,
              link: AI_SEARCH_PATH,
              enabled: isEnabled
            }
          ]
        };
      })
    );
  };
}
